import { getUserInfoUnitTest } from "services";

export const fNumberToLocalString = (number: any) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const fArrayNumberToLocalString = (numbers: any) => numbers.map((num: any) => fNumberToLocalString(num ?? 0));

export const fStringToNumber = (string: any) => parseInt(string.replace(/,/g, ''));

export const detectRegion = (mkp: string) => ['US', 'MX', 'CA'].includes(mkp) ? "NA" : "EU";

export const convertDateTime = (strTime: string | undefined | any) => {
  if (!strTime) {
    return 'None'
  }

  let t: string | number | undefined = undefined;

  if (typeof strTime === "string") {
    // Handle ISO 8601 format with nanoseconds: "2026-01-22T13:42:18.362738943Z"
    // JavaScript Date can parse this format directly
    t = strTime;
  } else if (typeof strTime === "object" && strTime !== null) {
    // Handle MongoDB date formats
    if ('$date' in strTime) {
      // MongoDB extended JSON: {"$date": "2024-01-01T00:00:00Z"} or {"$date": 1234567890}
      const dateValue = strTime.$date;
      if (typeof dateValue === 'string') {
        t = dateValue;
      } else if (typeof dateValue === 'number') {
        // Unix timestamp in milliseconds
        t = new Date(dateValue).toISOString();
      }
    } else if ('timestamp' in strTime) {
      // Timestamp object
      const timestamp = strTime.timestamp;
      if (typeof timestamp === 'number') {
        t = new Date(timestamp * 1000).toISOString(); // Convert seconds to milliseconds
      } else if (typeof timestamp === 'string') {
        t = timestamp;
      }
    } else if ('$oid' in strTime) {
      // MongoDB ObjectID - extract timestamp from ObjectID
      const oid = strTime.$oid;
      if (typeof oid === 'string' && oid.length === 24) {
        // ObjectID contains timestamp in first 8 hex characters
        const timestampHex = oid.substring(0, 8);
        const timestamp = parseInt(timestampHex, 16) * 1000; // Convert to milliseconds
        t = new Date(timestamp).toISOString();
      }
    } else {
      // Try to get first value (for backward compatibility)
      const values = Object.values(strTime);
      if (values.length > 0) {
        const firstValue = values[0];
        if (typeof firstValue === 'string') {
          t = firstValue;
        } else if (typeof firstValue === 'number') {
          t = new Date(firstValue).toISOString();
        }
      }
    }
  } else if (typeof strTime === "number") {
    // Unix timestamp
    t = new Date(strTime).toISOString();
  }

  if (!t) {
    return 'None'
  }

  const dateTime = new Date(t);
  // Check if date is valid
  if (isNaN(dateTime.getTime())) {
    return 'Invalid Date'
  }

  const month = new Intl.DateTimeFormat('en-US', { month: 'short' }).format(dateTime);
  const date = dateTime.getDate();
  const year = dateTime.getFullYear();
  const time = dateTime.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
  return `${month} ${date}, ${year} - ${time}`
}

export const getCookie = (name: string) => {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

export const getUserIdUsingSPAPI = async (email: string) => {
  return await getUserInfoUnitTest(email)
    .then(({ data: res }: any) => {
      const userId = res.data.user._id;
      // Handle MongoDB ObjectID: can be string or object with $oid
      if (typeof userId === 'string') {
        return userId;
      } else if (userId && typeof userId === 'object') {
        // Check for MongoDB extended JSON format: {"$oid": "..."}
        if ('$oid' in userId) {
          return userId.$oid as string;
        }
        // Otherwise, try to get the first value (for backward compatibility)
        const values = Object.values(userId);
        if (values.length > 0 && typeof values[0] === 'string') {
          return values[0] as string;
        }
      }
      return null;
    })
    .catch((err) => {
      console.error(err);
      return null;
    })
}

export const getIdFromObject: any = (obj: { _id: string }) => Object.values(obj._id)[0] as string

export const getIdFromObjectId: any = (objId: object) => objId ? Object.values(objId)[0] as string : null

export const convertToDate = (date_string: string) => date_string && new Date(date_string).toISOString()